import { STRATEGY_PARTNER_SLUGS } from "./strategy-partner-slugs";
import { MAG7_SPACEX_PORTFOLIO_HREF } from "~/features/campaigns/campaign-data";
import {
  STRATEGY_PARTNER_IMAGES,
  type CampaignImageAsset,
} from "~/features/strategy-partner/data/strategy-partner-assets.generated";

export type StrategyPartnerPortfolioStatus = "active" | "coming-soon";

export type StrategyPartnerPortfolioId = "mag7x" | "robotics" | "us-ai-leaders";

export interface StrategyPartnerPortfolio {
  readonly artwork: CampaignImageAsset;
  readonly id: StrategyPartnerPortfolioId;
  readonly status: StrategyPartnerPortfolioStatus;
  /** Card click target; portfolios without one render inert. */
  readonly strategyHref?: string;
}

export interface StrategyPartnerDefinition {
  readonly cover: CampaignImageAsset;
  readonly portfolios: readonly StrategyPartnerPortfolio[];
  readonly slug: string;
  /* i18n-exempt: domain names are fixed identifiers. */
  readonly websiteHref: string;
  readonly websiteLabel: string;
  readonly wordmark: {
    readonly height: number;
    readonly path: string;
    readonly width: number;
  };
}

export const BITWISE_STRATEGY_PARTNER: StrategyPartnerDefinition = {
  cover: STRATEGY_PARTNER_IMAGES.bitwiseCover,
  portfolios: [
    {
      artwork: STRATEGY_PARTNER_IMAGES.bitwiseMag7xCard,
      id: "mag7x",
      status: "active",
      strategyHref: MAG7_SPACEX_PORTFOLIO_HREF,
    },
    {
      artwork: STRATEGY_PARTNER_IMAGES.bitwiseRobotics,
      id: "robotics",
      status: "coming-soon",
    },
    {
      artwork: STRATEGY_PARTNER_IMAGES.bitwiseUsAiLeaders,
      id: "us-ai-leaders",
      status: "coming-soon",
    },
  ],
  slug: "bitwise",
  websiteHref: "https://bitwiseinvestments.com",
  websiteLabel: "bitwiseinvestments.com",
  wordmark: {
    height: 56,
    path: "/assets/logos/bitwise_wordmark.svg",
    width: 257,
  },
};

const STRATEGY_PARTNERS = {
  bitwise: BITWISE_STRATEGY_PARTNER,
} satisfies Record<
  (typeof STRATEGY_PARTNER_SLUGS)[number],
  StrategyPartnerDefinition
>;

export function getStrategyPartner(
  slug: string,
): StrategyPartnerDefinition | undefined {
  const normalizedSlug = slug.trim().toLowerCase();

  const key = STRATEGY_PARTNER_SLUGS.find((slug) => slug === normalizedSlug);
  return key === undefined ? undefined : STRATEGY_PARTNERS[key];
}
